import { Component } from 'react';
import propTypes from 'prop-types';

/**
 * @typedef {import('../../../../../types').RelatedProductsGroupInfo} RelatedProductsGroupInfo
 * @typedef {import('../../../../../stores/data/RelatedProducts/RelatedSectionStore').RelatedSectionStore} RelatedSectionStore
 */

export class RelatedGroups extends Component {
  /**
   * @param {object} props
   * @param {RelatedSectionStore} props.relatedStore
   */
  constructor(props) {
    super(props);
    this.relatedStore = props.relatedStore;
  }

  onClickGroups = (e) => {
    const { target } = e;

    if (target.classList.contains('related-section__group-item')) {
      const groupId = target.dataset.id;

      this.relatedStore.setGroupId(groupId);
    }
  };

  /**
   * @param {RelatedProductsGroupInfo} group
   */
  renderGroup = (group) => (
    <li className={this.getClassList(group)} data-id={group.groupId} key={group.groupId}>
      {group.productsCount > 1 ? `${group.viewProductLabel} (${group.productsCount})` : group.viewProductLabel}
    </li>
  )

  /**
   * @param {RelatedProductsGroupInfo} group
   * @returns {string}
   */
  getClassList = (group) => {
    let classList = 'related-section__group-item';

    if (this.relatedStore.selectedGroupId === group.groupId) {
      classList += ' related-section__group-item--active';
    }

    return classList;
  }

  render() {
    return (
      <ul className="related-section__groups" onClick={this.onClickGroups}>
        {this.relatedStore.relatedGroups.map(this.renderGroup)}
      </ul>
    );
  }
}

RelatedGroups.propTypes = {
  relatedStore: propTypes.shape({
    setGroupId: propTypes.func.isRequired,
    selectedGroupId: propTypes.string.isRequired,
    relatedGroups: propTypes.array.isRequired
  }).isRequired
};
